import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IonDatetime, IonModal, ModalController, NavController } from '@ionic/angular';
import { UserService } from 'octali-lib-firebase-utils';
import { DisplayerService } from 'octali-lib-utils';

import * as moment from 'moment';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {

  @ViewChild('datetime', { read: IonDatetime, static: false }) datetime: IonDatetime;
  @ViewChild('dateModal', { read: IonModal, static: false }) dateModal: IonModal;
  
  public signupForm: FormGroup;
  public maxDate:string;
  public dateValue: string;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private profileService: UserService,
    private displayer: DisplayerService,
    private modalCtrl: ModalController,
    private navCtrl: NavController
  ) { 
    this.maxDate = moment().subtract("18","y").format("YYYY-MM-DD");
  }

  ngOnInit() {
    this.signupForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['',Validators.required],
      password: ['',Validators.compose([Validators.minLength(6), Validators.required])],
      dateOfBirth: ['', Validators.required],
      phone: [null,Validators.compose([Validators.minLength(10), Validators.maxLength(10)])],
      mobile: [null,Validators.compose([Validators.minLength(10), Validators.maxLength(10)])],
    }, { validator: this.onePhone('phone','mobile')}
    );
  }

  // test au moins 1 téléphone
  onePhone(phone: string, mobile: string) {
    return (group: FormGroup): {[key: string]: any} => {
       let phoneControl = group.controls[phone];
       let mobileControl = group.controls[mobile];
       if((phoneControl.value == null ||phoneControl.value == "") && (mobileControl.value == null || mobileControl.value == ""))
       return {
        'onePhone': true
        };
       
    }
  }

  changeDate( date ) {
    console.log(date);
    this.dateValue = date;
    this.signupForm.controls.dateOfBirth.setValue(moment(date).format("DD-MM-yyyy"));
  }

  confirm() {
    this.datetime.confirm();
    this.dateModal.dismiss();
  }

  cancel() {
    this.datetime.cancel();
    this.dateModal.dismiss();
  }
  
  reset() {
    this.datetime.reset();
  }

  async userSignup(signupForm: FormGroup): Promise<void> {
    if (!signupForm.valid) {
      console.log(signupForm.value);
    } else {
      await this.displayer.presentLoader();
      this.profileService.signup(
        signupForm.value.email,
        signupForm.value.password
      ).then(async () => {
        await this.displayer.dismissLoader();
        this.profileService.getUser().subscribe( user => {
          if( user ){
            user.firstname = signupForm.value.firstname;
            user.lastname = signupForm.value.lastname;
            user.mail = signupForm.value.email;
            user.phone = signupForm.value.phone;
            user.mobile = signupForm.value.mobile;
            user.dateOfBirth = this.dateValue;
            user.isAdmin = false;
            user.isAnonym = false;
            user.isVerified = false;
            user.tokens = null;
            user.actif = true;
            this.profileService.updateUser( user ).then( async res => {
              if(res){
                this.navCtrl.navigateRoot("accueil");
                this.close();
               
              }
                
            });
          }
        });

      },async error => {
        await this.displayer.dismissLoader();
        this.displayer.presentAlert("Erreur","",error.message);
          
      }
    );}
  }

  async close() {
    const modal = await this.modalCtrl.getTop();
    if(modal)
      modal.dismiss();
  }

}
